export const PosTerminal = (hotelId: string) => `pos-terminal-${hotelId}`
export const SalesManagerDashboardFilterOption = (hotelId: string) => `SalesManagerDashboardFilterOption-${hotelId}`
export const CleaningManagerListPreference = (hotelId: string) => `cleaning-manager-list-preference-${hotelId}`
export const SelectedLanguage = 'lang'
